module.exports = __webpack_public_path__ + "img/logo-n.4a824323.png";